export const onboardingStrings = {
  business_details: [
    {
      heading: "Small Business ",
      text: "You’re a small seller or business and want to track a few products.",
    },
    {
      heading: "Freelancer / Agency ",
      text: "You’re a freelancer or part of an agency, that’s helping multiple other sellers or brands analyze feedback.",
    },
    {
      heading: "Large Brand ",
      text: "You’re a large business, seller or brand and want to analyse customer feedback from multiple sources.",
    },
    {
      heading: "None of the above ",
      text: "Do tell us more about you. What brings you to Currents?",
    },
  ],
}
